<template>
  <div>
    <div class="panel panel--minimal-pad">
      <div class="panel__header">
        <div class="panel__header__left panel__header-width-m">
          <div class="search-form width-100">
            <span class="search hidden--xs">
              <span class="search__icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <path fill="#919EAB" fill-rule="evenodd" d="M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8m9.707 4.293l-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414"/>
                  </svg>
              </span>
              <span class="search__input">
                  <input type="text" class="form__input" placeholder="Search transfers">
              </span>
            </span>
          </div>
        </div>
        <div class="panel__header__right">
          <div class="filter__options">
            <button class="btn btn--default btn--flex">
            <span class="btn__icon">
              <svg class="" enable-background="new 0 0 971.986 971.986" version="1.1" viewBox="0 0 971.986 971.986" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                  <path fill="#576ae6" d="m370.22 459.3c10.2 11.1 15.8 25.6 15.8 40.6v442c0 26.601 32.1 40.101 51.1 21.4l123.3-141.3c16.5-19.8 25.6-29.601 25.6-49.2v-272.8c0-15 5.7-29.5 15.8-40.601l353.8-383.9c26.5-28.8 6.101-75.5-33.1-75.5h-873c-39.2 0-59.7 46.6-33.1 75.5l353.8 383.8z" />
              </svg>
            </span>
              <span class="btn__text">Add filter</span>
            </button>
          </div>
          <div class="select filter__date">
            <select name="disburse-source" id="disburseSource" class="select__input select__input--sm">
              <option value="Bank source">Today</option>
              <option value="Card source">Yesterday</option>
            </select>
            <div class="select__icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="6" height="10" viewBox="0 0 6 10"><path fill="#42476f" fill-rule="evenodd" d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z"></path></svg>
            </div>
          </div>
        </div>
      
      </div>
      <div class="panel__content panel__content--grey outer-container">
        <div class="table__section table__section--head">
          Showing <span>all scheduled transfers</span>
        </div>
        <!--scheduled transfers table-->
        <div class="table">
          <!-- Table body -->
          <div class="table__section table__section--body">
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Today</div>
                <div class="table__data--sub">Oct 23, 2017</div>
              </div>
              
              
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Scheduled by: <span class="table__data--result"> Yele </span></div>
              
              </div>
              
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
            
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Today</div>
                <div class="table__data--sub">Oct 23, 2017</div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Scheduled by: <span class="table__data--result"> Felix (You) </span></div>
    
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
            
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Today</div>
                <div class="table__data--sub">Oct 23, 2017</div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Scheduled by: <span class="table__data--result"> Tolu </span></div>
    
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
            
            <!-- table row -->
            <div class="table__row">
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--bold">
                  $ 12,280,000
                </div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">JR Washington</div>
                <div class="table__data--sub">GTB Bank (****2086))</div>
              </div>
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Today</div>
                <div class="table__data--sub">Oct 23, 2017</div>
              </div>
    
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--default">Scheduled by: <span class="table__data--result"> Yele </span></div>
    
              </div>
    
              <!-- table data -->
              <div class="table__data">
                <div class="table__data--actions textRight">
                  <button class="btn btn--flat btn--compact btn--edit">Edit</button>
                  <button class="btn btn--flat btn--compact btn--cancel">Cancel</button>
                </div>
              </div>
            </div>
            
            <div class="table__row spacer"></div>
          
          </div>
        </div>
      </div>
    </div>
    <pagination></pagination>
  </div>

</template>

<script>
  import PaginationView from '@/components/partials/PaginationView'
  
  export default {
    
    data() {
      return {
      }
    },
    components:{
      'pagination': PaginationView
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/transfers/ScheduledTransfers.vue